import React from 'react';
import Modal from 'react-modal';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import RegisterForm from 'RegisterForm';
import withInit from 'WithInit';
import RegisterFormTOSPositionEnum from 'RegisterForm/RegisterFormConstants';
import { closeCreateAccountModal } from 'StaticBuilder/StaticBuilderActions';
import styles from '../../../sass/main.scss';

const defaultModalStyle = {
  overlay: {
    background: 'rgba(0, 0, 0, 0.5)',
    zIndex: styles.modalZIndex,
  },
  content: {
    border: 'none',
    borderRadius: '4px',
    background: 'transparent',
    height: '447px',
    margin: '0 auto',
    overflow: 'visible',
    padding: '0',
    width: '677px',
    backgroundColor: '#fff',
  },
};

class StaticBuilderCreateAccount extends React.PureComponent {
  constructor(props) {
    super(props);

    this.closeCreateAccountModal = this.closeCreateAccountModal.bind(this);
  }

  closeCreateAccountModal() {
    this.props.closeCreateAccountModal();
    if (this.props.hasFormSwiftLogoBeenClicked) {
      window.location.assign('/');
    }
  }

  render() {
    return (
      <Modal
        ariaHideApp={false}
        isOpen={this.props.isCreateAccountModalOpen}
        style={defaultModalStyle}
      >
        <div className="static-builder-create-account-modal-wrapper">
          <button
            className="modal-close-btn"
            onClick={this.closeCreateAccountModal}
          />
          <div className="static-builder-create-account-modal-form-wrapper">
            <RegisterForm
              displayTOS={RegisterFormTOSPositionEnum.NONE}
              documentType={this.props.documentType}
              heading="Create a Free Account to Save Your Document"
              hideConfirmPassword={false}
              redirectToPage={window.location.href}
              sessionHash={this.props.sessionHash}
              sessionKey={this.props.sessionId}
            />
          </div>
          <div className="static-builder-create-account-modal-sidebar-wrapper">
            <img
              alt="free flag icon"
              className="static-builder-create-account-modal-free-flag-icon"
              src="/images/free-flag.png"
            />
            <p className="static-builder-create-account-modal-info-text">
              Create a free account to save your progress on this form.
              You can come back to it at any time.
            </p>
            <p className="static-builder-create-account-modal-sign-in-text">
              Already have an account?
              <a href="/sign-in">Sign in here</a>.
            </p>
          </div>
        </div>
      </Modal>
    );
  }
}

StaticBuilderCreateAccount.defaultProps = {
  sessionHash: '',
  sessionId: '',
};

StaticBuilderCreateAccount.propTypes = {
  closeCreateAccountModal: PropTypes.func.isRequired,
  documentType: PropTypes.string.isRequired,
  hasFormSwiftLogoBeenClicked: PropTypes.bool.isRequired,
  isCreateAccountModalOpen: PropTypes.bool.isRequired,
  sessionHash: PropTypes.string,
  sessionId: PropTypes.string,
};

const mapStateToProps = ({ StaticBuilderReducer }) => (
  {
    documentType: StaticBuilderReducer.documentType,
    hasFormSwiftLogoBeenClicked: StaticBuilderReducer.hasFormSwiftLogoBeenClicked,
    isCreateAccountModalOpen: StaticBuilderReducer.isCreateAccountModalOpen,
    sessionHash: StaticBuilderReducer.sessionHash,
    sessionId: StaticBuilderReducer.sessionId,
  }
);

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    closeCreateAccountModal,
  }, dispatch)
);

export const StaticBuilderCreateAccountWithRedux = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(StaticBuilderCreateAccount);

export default withInit(StaticBuilderCreateAccountWithRedux, true);



// WEBPACK FOOTER //
// ./src-react/Modals/StaticBuilderCreateAccount/index.jsx